import React, { useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { getJobTransactionsDateGaps } from "../../../../docuclipper/api";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AgTable from "../AnalyzeTransactionsTable/AgTable";
import { flatten } from "lodash";
import moment from "moment";
var filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    const dateAsString = cellValue;
    if (dateAsString === null) return -1;
    const cellDate = moment(dateAsString, "YYYY-MM").toDate();
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
};

type Props = {};
export const DateGaps: React.FC<Props> = ({}) => {
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const { job } = useSelector((state: ReduxState) => state.JobData);

  const [dateGaps, setDateGaps] = React.useState({});

  const accounts = Object.keys(dateGaps);
  const months: { [k: string]: boolean } =
    accounts.length > 0 ? dateGaps[accounts[0]] : [];

  const jobId = job ? job.id : "";

  const getGaps = () => {
    if (jobId) {
      getJobTransactionsDateGaps(jobId, startDate, endDate)
        .then((dateGaps) => setDateGaps(dateGaps))
        .catch((e) => null);
    }
  };
  React.useEffect(() => {
    if (Object.keys(dateGaps).length === 0) {
      getGaps();
    }
  }, []);

  //     {Object.keys(dateGaps[accounts[0]])
  //       .sort()
  //       .map((month, i) => (
  //         <tr key={i}>
  //           <td>{month}</td>
  //           {accounts.map((account, j) => (
  //             <td key={`${i}-${j}`}>
  //               {dateGaps[account][month] ? (
  //                 <FontAwesomeIcon icon="check" />
  //               ) : (
  //                 <FontAwesomeIcon icon="times" />
  //               )}
  //             </td>
  //           ))}
  //         </tr>
  //       ))}

  const data = flatten(
    Object.keys(dateGaps || {}).map((account) =>
      Object.keys(dateGaps[account] || {}).map((month) => ({
        account,
        month,
        value: dateGaps[account][month],
      }))
    )
  );

  const [columnDefs] = useState([
    {
      headerName: "Account",
      field: "account",
      filter: "agSetColumnFilter",
      filterParams: {
        // pass in additional parameters to the Text Filter
      },
    },
    {
      headerName: "Month",
      field: "month",
      filter: "agDateColumnFilter",
      filterParams: filterParams,
    },
    {
      headerName: "Value",
      field: "value",
      filter: "agSetColumnFilter",
      filterParams: {
        // pass in additional parameters to the Number Filter
      },
      cellRenderer: function (params) {
        const cellValue = params.value.toString(); // Get the value to display in the cell
        if (cellValue === "true") {
          return <FontAwesomeIcon icon="check" />;
        } else {
          return <FontAwesomeIcon icon="times" />;
        }
      },
    },
  ]);

  return (
    <div>
      <Row className="mt-4">
        <Col md="2">
          <Form.Group>
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md="2">
          <Form.Group>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md="4" className="text-right m-1">
          <Button
            onClick={() => {
              getGaps();
            }}
          >
            Calculate Date Gaps
          </Button>
        </Col>
      </Row>

      <div className="mt-4">
        {accounts.length > 0 && (
          <AgTable
            hasExport={true}
            columnDefs={columnDefs}
            rowData={data}
            height={400}
            width={900}
          />
          // <Table responsive>
          //   <thead>
          //     <tr>
          //       <td>Date</td>
          //       <td>Accounts</td>
          //     </tr>
          //   </thead>
          //   <tbody>
          //     <tr>
          //       <td></td>
          //       {accounts.map((account) => (
          //         <td>{account}</td>
          //       ))}
          //     </tr>
          //     {Object.keys(dateGaps[accounts[0]])
          //       .sort()
          //       .map((month, i) => (
          //         <tr key={i}>
          //           <td>{month}</td>
          //           {accounts.map((account, j) => (
          //             <td key={`${i}-${j}`}>
          //               {dateGaps[account][month] ? (
          //                 <FontAwesomeIcon icon="check" />
          //               ) : (
          //                 <FontAwesomeIcon icon="times" />
          //               )}
          //             </td>
          //           ))}
          //         </tr>
          //       ))}
          //   </tbody>
          // </Table>
        )}
      </div>
    </div>
  );
};
export default DateGaps;
